import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Form, Field, reduxForm } from 'redux-form';
import { Row, Col, Button } from 'react-bootstrap';
import styled from 'styled-components';
import ButtonLiquidPrimary from 'components/atoms/buttons/liquid/Primary';
import TextInput from 'components/atoms/inputs/TextInput';
import LoginButtonWrapper from 'components/atoms/form/LoginButtonWrapper';
import LoginLinkWrapper from 'components/atoms/form/LoginLinkWrapper';
import LoginLink from 'components/atoms/form/LoginLink';
import { submitLoginForm, navigateToOktaBroker } from 'services/auth/duck';
import { ScaleLoader } from 'react-spinners';

const InstructionText = styled.p`
  font-size: 16px;
`;

const LoginHr = styled.hr`
  margin: 2.357em -2.357em 0;
  border-color: #979797;
`;

const SignInRow = styled(Row) `
  margin-bottom: -2.357em;
`;

const SsoButton = styled(Button) `
  margin: 17px 0;
  padding: 0;
  font-size: 16px;
  width: 100%;
  height: 24px;
`;

const Overlay = styled.div`
    height: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

class LoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clickedSSO: false
        };
    }

    clickedSSO = () => {
        this.setState({
            clickedSSO: true
        });
        this.props.navigateToOktaBroker();
    };

    render() {
        let ssoMarkup = null;

        if (!this.props.hideSSO) {
            const innerComp = this.state.clickedSSO ? (
                <Overlay>
                    <ScaleLoader
                        loading={this.state.clickedSSO}
                        color={'#5a80c4'}
                    />
                </Overlay>
            ) : (
                <SsoButton bsStyle='link' onClick={() => this.clickedSSO()}>
                    Sign in using SSO
                </SsoButton>
            );

            ssoMarkup = (
                <React.Fragment>
                    <LoginHr />
                    <SignInRow>
                        <Col xs={12}>
                            {innerComp}
                        </Col>
                    </SignInRow>
                </React.Fragment>
            );
        }

        return (
            <Form onSubmit={this.props.handleSubmit(submitLoginForm)} id="loginForm">
                <InstructionText>Sign in to your Account</InstructionText>

                <Field component={TextInput} name="email" label="EMAIL" type="text" disabled={this.state.clickedSSO}/>
                <Field component={TextInput} name="password" label="PASSWORD" type="password" disabled={this.state.clickedSSO}/>

                <Row>
                    <Col xs={12} sm={6}>
                        <LoginButtonWrapper>
                            <ButtonLiquidPrimary type="submit" disabled={this.state.clickedSSO}>SIGN IN</ButtonLiquidPrimary>
                        </LoginButtonWrapper>
                    </Col>
                    <Col xs={12} sm={6}>
                        <LoginLinkWrapper>
                            <LoginLink to="/login/forgot-password">Forgot Password?</LoginLink>
                        </LoginLinkWrapper>
                    </Col>
                </Row>
                {ssoMarkup}
            </Form>

        );
    }
}

export default compose(
    connect(null, { navigateToOktaBroker }),
    reduxForm({
        form: 'login',
    })
)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/organisms/forms/Login.js